import mvlac from '../assets/images/hotel/mvlac.jpeg';
import res from '../assets/images/hotel/res.jpg';
import four from '../assets/images/hotel/four.png';
import darmar from '../assets/images/hotel/darmar.png';
import nine from '../assets/images/hotel/thenine.png';
import rad from '../assets/images/hotel/rad.jpg';
import sind from '../assets/images/hotel/sind.png';
import bad from '../assets/images/hotel/bad.png';
import mvs from '../assets/images/hotel/mvsousse.jpeg';
import royal from '../assets/images/hotel/royal.png';
import sheraton from '../assets/images/hotel/sheraton.jpg';

const HOTELList = [
    {
        name: "Mövenpick Hotel du Lac Tunis",
        img: mvlac,
        url: "https://movenpick.accor.com/"
    },
    {
        name: "Résidence Gammarth",
        img: res,
        url: "https://www.cenizaro.com/theresidence/tunis"
    },
    {
        name: "Four Seasons Gammarth",
        img: four,
        url: "https://www.fourseasons.com/tunis/"
    },
    {
        name: "Dar El Marsa",
        img: darmar,
        url: "https://www.darelmarsa.com/"
    },
    {
        name: "The Nine Lifestyle",
        img: nine,
        url: "https://www.thenine-experience.com/"
    },
    {
        name: "Radisson Blu Hotel & Convention Center, Tunis",
        img: rad,
        url: "https://www.radissonhotels.com/en-us/"
    },
    {
        name: "Hôtel Sindbad Hammamet",
        img: sind,
        url: "https://sindbadhotel.com/"
    },
    {
        name: "La Badira Hammamet",
        img: bad,
        url: "https://www.labadira.com/"
    },
    {
        name: "Mövenpick Resort & Marine Spa Sousse",
        img: mvs,
        url: "https://movenpick.accor.com/"
    },
    {
        name: "Royal Tulip Korbous",
        img: royal,
        url: "https://royal-tulip-korbous.goldentulip.com/en-us/?sr=SEO_GOOGLE"
    },
    {
        name: "Sheraton Tunis",
        img: sheraton,
        url: "https://www.marriott.com/en-us/hotels/tunsi-sheraton-tunis-hotel/overview/"
    },
];

export default HOTELList;